import "core-js/modules/es.number.constructor.js";
import React from 'react';
import Comments from 'components/Comments';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PlaylistComments(_ref) {
  var playlist = _ref.playlist;
  return /*#__PURE__*/_jsx(Comments, {
    contentId: Number(playlist.id),
    contentType: "playlist",
    size: "LARGE",
    totalCount: playlist.commentCount
  });
}